<app-header></app-header>

<!--============ Breadcumb ============= -->
<div class="breadcumb-wrapper" data-bg-src="assets/img/bg/breadcumb-bg.jpg">
    <div class="container">
        <div class="breadcumb-content">
            <h1 class="breadcumb-title">Project Analysis</h1>
            <ul class="breadcumb-menu">
                <li><a routerLink="/">Home</a></li>
                <li>Analysis</li>
            </ul>
        </div>
    </div>
</div>

<section class="space">
    <div class="container">
        <div class="row">
            <div class="col-xxl-8 col-lg-7">
                <div class="page-single">
                    <div class="service-img sv-details-img">
                        <img class="w-100" src="assets/img/service/hagency-post-5.webp" alt="Project Analysis" />
                    </div>
                    <div class="page-content sv-content d-block">
                        <h2 class="box-title">Planning and Requirement Gathering</h2>
                        <p class="box-text mb-30">Planning and requirement gathering for a web application refer to the
                            process of identifying and documenting the necessary features, functionality, and
                            specifications that the application should have to meet the needs of its users. It involves
                            gathering information from stakeholders, understanding their objectives, and defining the
                            scope of the web application project.
                        </p>
                        <div class="sv-gallery-wrapper">
                            <h2 class="box-title">Why Project Analysis Important?</h2>
                            <p>During the planning phase, the key activities include:</p>
                            <div class="row gy-4">
                                <div class="col-6">
                                    <div class="sv-sm-img">
                                        <img class="w-100" src="assets/img/service/video-image-1.jpg.webp" alt="" />
                                    </div>
                                </div>
                                <div class="col-6 my-5">
                                    <div class="checklist tick-checklist sv-details-list mb-40">
                                        <ul class="list">
                                            <li>Identifying goals and objectives</li>
                                            <li>Defining scope</li>
                                            <li>Conducting market research</li>
                                            <li>Creating user personas</li>
                                            <li>Conducting user interviews and surveys</li>
                                            <li>Creating user stories</li>
                                            <li>Defining functional and non-functional requirements</li>
                                            <li>Prioritizing requirements</li>
                                            <li>Creating wireframes and prototypes</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row gy-4">
                                <div class="col-12">
                                    <p>By undertaking thorough planning and requirement gathering, the development team
                                        can have a clear understanding of what needs to be built, minimizing
                                        misunderstandings, and increasing the chances of creating a successful web
                                        application that meets the users’ needs and expectations.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xxl-4 col-lg-5">
                <app-service-sidebar></app-service-sidebar>
            </div>
        </div>
    </div>
</section>

<!--======== Footer Section ========-->
<app-footer></app-footer>